import _ from 'lodash';
import { Component, OnInit, Input, OnDestroy, ViewEncapsulation, HostListener } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { SharedService } from '../../services/shared.service';

import { loadVirtualEvent, clearVirtualEventData, updateVirtualEventPresent, setVirtualEventPresentationMode } from 'app/virtual-event/features/data/data.actions';
import { loadVirtualEventSummary, clearVirtualEventSummary } from 'app/virtual-event/features/summary/summary.actions';
import { clearVirtualEventActivity } from 'app/virtual-event/features/activity/activity.actions';
import { loadEventCampaignList, clearCampaignList } from 'app/campaign/features/campaign.actions';

import { clearVirtualEventLastHero } from 'app/virtual-event/features/last-hero/last-hero.actions';
import { selectVirtualEventData } from 'app/virtual-event/features/data/data.selectors';
import { WebSocketModel } from '../../models/web-socket.model';
import { ToastService } from 'app/toast/services/toast.service';
import { ResizeService } from 'app/core/services/resize.service';

import {BreakpointObserver} from '@angular/cdk/layout';
import { updateResolutionLayout } from 'app/core/features/layout.actions';
import { first } from 'rxjs/operators';
import { TransformService } from 'app/core/services/transform.service';
import { selectChatStatus } from 'app/chat/features/chat.selectors';
import { MdbSelectComponent } from 'mdb-angular-ui-kit/select';

@Component({
  selector: 'app-virtual-event-run',
  templateUrl: './virtual-event.component.html',
  styleUrls: ['./virtual-event.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VirtualEventRunComponent implements OnInit, OnDestroy {
  @Input() id: string = null;
  @Input() token: string = null;
  @Input() payload: any = null;

  private ws: WebSocketModel = null;

  public event$: any = this.store.pipe(select(selectVirtualEventData));
  public chatStatus$: any = this.store.pipe(select(selectChatStatus));

  public classname: string = null;
  public theme:string = null
  public showRegularMode: boolean = true;
  public list: any[] = [{
    name: 'dark',
    label: 'Dark Mode'
  }, {
    name: 'light',
    label: 'Light Mode'
  }];

  public modeList: any[] = [{
    name: 'regular',
    label: 'Producer'
  }, {
    name: 'auctioneer',
    label: 'Auctioneer'
  }];

  public options: any = {
    'key': 'label'
  };
  public selected: any = null;
  public selectedMode: any = null;
  public selectClassOne: string = ''
  public selectClassTwo: string = ''

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resizeService.resizeSubject.next(event);
  }

  constructor(
    private store: Store<any>,
    private resizeService: ResizeService,
    private toastService: ToastService,
    private sharedService: SharedService,
    private transformService: TransformService,
    private breakpointObserver: BreakpointObserver
  ) { }

  ngOnInit(): void {
    const id = _.isNull(this.id) ? _.get(this.payload, 'id', null): this.id;
    const token = _.isNull(this.token) ? this.sharedService.token: this.token;

    const selected = _.find(this.list, { 'name': 'dark' });
    this.onSelect(selected);

    const selectedMode = _.find(this.modeList, { 'name': 'regular' });
    this.onSelectMode(selectedMode);

    this.sharedService.id = id;
    this.sharedService.token = token;

    this.ws = new WebSocketModel(id, this.store, this.toastService, this.sharedService, this.transformService);

    this.store.dispatch({
      type: loadVirtualEvent.type,
      payload: id
    });
    this.store.dispatch({
      type: loadVirtualEventSummary.type,
      payload: id
    });
    this.store.dispatch({
      type: loadEventCampaignList.type,
      payload: token
    });

    this.breakpointObserver.observe([
      '(max-width: 575px)'
    ]).subscribe(result => {
      if(result.matches) {
        this.store.dispatch({
          type: updateResolutionLayout.type,
          payload: 'xs'
        })
      }
    });

    this.breakpointObserver.observe([
      '(min-width: 576px) and (max-width: 767px)'
    ]).subscribe(result => {
      if(result.matches) {
        this.store.dispatch({
          type: updateResolutionLayout.type,
          payload: 'sm'
        })
      }
    });

    this.breakpointObserver.observe([
      '(min-width: 768px) and (max-width: 991px)'
    ]).subscribe(result => {
      if(result.matches) {
        this.store.dispatch({
          type: updateResolutionLayout.type,
          payload: 'md'
        })
      }
    });

    this.breakpointObserver.observe([
      '(min-width: 992px) and (max-width: 1199px)'
    ]).subscribe(result => {
      if(result.matches) {
        this.store.dispatch({
          type: updateResolutionLayout.type,
          payload: 'lg'
        })
      }
    });

    this.breakpointObserver.observe([
      '(min-width: 1200px)'
    ]).subscribe(result => {
      if(result.matches) {
        this.store.dispatch({
          type: updateResolutionLayout.type,
          payload: 'xl'
        })
      }
    });

    const $ = window['$'];
    $("#paymentDuePopup").css("marginTop", "0px");
    $("#invoiceDuePopup").css("marginTop", "0px");

    window["Intercom"]('update', {"hide_default_launcher": true});
  }

  ngOnDestroy() {
    this.store.dispatch({
      type: clearVirtualEventData.type
    });
    this.store.dispatch({
      type: clearVirtualEventSummary.type
    });
    this.store.dispatch({
      type: clearVirtualEventActivity.type
    });
    this.store.dispatch({
      type: clearVirtualEventLastHero.type
    });
    this.store.dispatch({
      type: clearCampaignList.type
    });

    this.ws.subject.complete();
    this.ws.connection.unsubscribe();

    this.ws.takeUntilSubject.next(null);
    this.ws.takeUntilSubject.complete();

    const $ = window['$'];
    $("#paymentDuePopup").css("marginTop", "62.5px");
    $("#invoiceDuePopup").css("marginTop", "62.5px");

    window["Intercom"]('update', {"hide_default_launcher": false});
  }

  onClickSelect(event, select: MdbSelectComponent) {
    event.preventDefault();
    event.stopPropagation();
    return select.isExpanded ? select.close(): select.open();
  }

  onSelect(mode) {
    this.selected = mode;
    this.classname = `virtual-event--${mode.name}-mode`;
    this.theme = mode.name
  }

  onSelectMode(mode) {
    this.selectedMode = mode;
    this.showRegularMode = mode && mode.name === 'regular';
  }

  getDropdownToggleLabel() {
    return _.isNull(this.selected) ? 'Select Mode': _.get(this.selected, 'label', 'Select Mode');
  }

  getSelectedModeLabel() {
    return _.isNull(this.selectedMode) ? 'Select Mode': _.get(this.selectedMode, 'label', 'Select Mode');
  }

  onClear(campaignId, option, clear = false) {
    this.store.dispatch({
      type: updateVirtualEventPresent.type,
      payload: {
        eventId: this.sharedService.id,
        campaignId, option, clear
      }
    });
  }

  onSetPresentationMode(presentationMode) {
    return this.store.pipe(
      select(selectVirtualEventData),
      first()
    ).subscribe(data => {
      this.store.dispatch({
        type: setVirtualEventPresentationMode.type,
        payload: {
          eventId: data.id,
          presentationMode
        }
      })
    });
  }
  addClass(num){
    if(num=='1'){
      this.selectClassOne='opened'
    }
    if(num=='2'){
      this.selectClassTwo='opened'
    }
  }
  removeClass(num){
    if(num=='1'){
      this.selectClassOne=''
    }
    if(num=='2'){
      this.selectClassTwo=''
    }
  }

}
